<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-row no-gutters>
        <v-col>
          <v-card class="pa-2 ma-2" outlined tile>
            <!-- toolbar -->
            <reference-tool-bar
              :title="options.title.main"
              :editedIndex="editedIndex"
              :createItemTitle="options.title.create"
              :formTitle="formTitle"
              :dialog="dialog"
              @save="save"
              @close="close"
              @open="open"
            >
              <template v-slot:formCreateEdit>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.name"
                    label="Наименование"
                    :hint="`Введите название операции`"
                    :rules="[rules.required, rules.min, rules.alfabet]"
                    autofocus
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-select
                    v-model="deviceSelect"
                    :hint="
                      `Идентификатор типа устройства - [${deviceSelect.id}]`
                    "
                    :items="deviceList"
                    item-text="name"
                    item-value="id"
                    label="Типы устройств"
                    persistent-hint
                    return-object
                    single-line
                  >
                  </v-select>
                </v-flex>
              </template>
            </reference-tool-bar>
            <!--Таблица с данными-->
            <reference-table
              :headers="options.headers"
              :items="options.data"
              @edit-item="editItem($event)"
              @remove-item="removeItem($event)"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { Vue } from "vue-property-decorator";
import { get } from "vuex-pathify";
import { mapActions } from "vuex";
import { rules } from "@/util/rules";

export default Vue.extend({
  name: "Operation.vue",
  components: {
    ReferenceTable: () => import("@/components/reference/ReferenceTable.vue"),
    ReferenceToolBar: () =>
      import("@/components/reference/ReferenceToolBar.vue")
  },
  computed: {
    options: get("reference/optionsOperation"),
    deviceList: get("reference/getDevice"),
    formTitle() {
      return this.editedIndex === -1 ? "Создать" : "Редактировать";
    }
  },
  data() {
    return {
      rules,
      dialog: false,
      editedIndex: -1,
      deviceSelect: 0
    };
  },
  methods: {
    ...mapActions({
      fetchReference: "reference/fetchOperations",
      fetchDevice: "reference/fetchDevice"
    }),
    initialize() {
      this.fetchDevice().then(result => {
        this.deviceSelect = this.deviceList[0];
      });
      this.fetchReference();
    },
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.options.editedItem = Object.assign({}, this.options.defaultItem);
        this.deviceSelect = this.deviceList[0];
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      const model = {
        deviceTypeId: this.deviceSelect.id,
        id: this.options.editedItem.id,
        name: this.options.editedItem.name
      };
      if (this.editedIndex > -1) {
        this.$http.put(this.options.path.base, model).then(response => {
          if (response.status === "Ok") this.initialize();
        });
      } else {
        model.id = 0;
        this.$http.post(this.options.path.base, model).then(response => {
          if (response.status === "Ok") this.initialize();
        });
      }
      this.close(false);
    },
    editItem(item) {
      this.editedIndex = this.options.data.indexOf(item);
      this.options.editedItem = Object.assign({}, item);
      this.deviceSelect = {
        id: item.deviceType.id,
        name: item.deviceType.Name
      };
      this.open();
    },
    removeItem(item) {
      console.log("Удаление через веб-интерфейс не предусмотрено");
      // if (confirm("Are you sure you want to delete this item?")) {
      //   const model = Object.assign({}, item);
      //   this.$http
      //     .delete(this.options.path.base, { data: model })
      //     .then((response) => {
      //       if (response.status === "Ok") this.initialize();
      //     });
      // }
    }
  },
  created() {
    this.initialize();
  }
});
</script>
